import { useCallback, useEffect, useState } from 'react';

import { getLines, getPositions } from '../services/adminContracts';
import { mapperLine, mapperPosition } from '../utils/mapper';
import { validateDecimalInput } from '../utils/formatUtils';

import useToast from './useToast';

const useMultiplPositionAndLine = ({ contractNumber, isMonthly }) => {
  const [pLFieldArrayValues, setPLFieldArrayValues] = useState([{}]);
  const [lines, setLines] = useState([]);
  const [loading, setLoading] = useState(false);
  const [positions, setPositions] = useState([]);
  const { setNewToast } = useToast();

  const changeLoaderState = (loadingState) => {
    setLoading(loadingState);
  };

  const changeLineState = (linesState) => {
    setLines(linesState);
  };
  const changePLFieldArrayValues = (pLFielArrayValuesState) => {
    setPLFieldArrayValues(pLFielArrayValuesState);
  };

  const handleSetLines = useCallback(
    (responseLines, index) => {
      const mappedLines = mapperLine(responseLines);

      const newLinesState = [...lines];

      newLinesState.splice(index, 1, mappedLines);

      setLines(newLinesState);
    },
    [lines]
  );
  const fetchPositions = useCallback(async () => {
    try {
      setLoading(true);
      const responsePositions = await getPositions(contractNumber, isMonthly);
      const positionAdapter = mapperPosition(responsePositions.data);

      setPositions(positionAdapter);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      setNewToast({
        type: 'error',
        message: err.message
      });
    }
  }, [contractNumber, isMonthly, setNewToast]);

  const fetchLines = useCallback(
    async (val, index) => {
      try {
        setLoading(true);
        const query = isMonthly
          ? getLines(contractNumber, val?.numeroPosicion, isMonthly)
          : getLines(contractNumber, val?.numeroPosicion, false);
        const responseLines = await query;

        handleSetLines(responseLines?.data, index);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        setNewToast({
          type: 'ERROR',
          message: error.message
        });
      }
    },
    [contractNumber, setNewToast, handleSetLines, isMonthly]
  );
  const duplicatePositionLine = () => {
    const idsPositionLine = new Set(
      pLFieldArrayValues.map(({ position, line }) => `${position?.id}-${line?.id}`)
    );

    return idsPositionLine.size !== pLFieldArrayValues.length;
  };
  const handleAddPL = () => {
    const newPLFieldArrayValue = [...pLFieldArrayValues, {}];

    setPLFieldArrayValues(newPLFieldArrayValue);
  };
  const handleSuprPL = (pLIndex) => {
    const newPLFieldArrayValue = pLFieldArrayValues.filter((_, index) => index !== pLIndex);
    const newLines = lines.filter((_, index) => index !== pLIndex);

    setPLFieldArrayValues(newPLFieldArrayValue);
    setLines(newLines);
  };
  const handleChangeLineValue = (val, index) => {
    const newPLFieldArrayValues = [...pLFieldArrayValues];

    newPLFieldArrayValues[index] = { ...newPLFieldArrayValues[index], line: val };

    setPLFieldArrayValues(newPLFieldArrayValues);
  };
  const handleChangePosition = (posValue, index) => {
    const newPLFieldArrayValue = [...pLFieldArrayValues];

    newPLFieldArrayValue[index] = { position: posValue, line: null };

    setPLFieldArrayValues(newPLFieldArrayValue);
  };

  const handleChangeAmount = (amountValue, index) => {
    const newPLFieldArrayValue = [...pLFieldArrayValues];

    newPLFieldArrayValue[index] = { ...newPLFieldArrayValue[index], amount: amountValue };
    setPLFieldArrayValues(newPLFieldArrayValue);
  };

  const handleChangeAmountValue = (val, index) => {
    const { value } = val.target;

    if (validateDecimalInput(value, 5)) {
      handleChangeAmount(value, index);
    }
  };
  const handleChangePositionValue = (val, index) => {
    fetchLines(val, index);
    handleChangePosition(val, index);
  };

  const isNullOrEmptyObj = (val) => !val || Object.keys(val).length === 0;
  const hasNullOrEmptyObj = (obj) =>
    Object.values(obj).some(isNullOrEmptyObj) || Object.keys(obj).length === 0;
  // isArrayEmpty verifica que el primer objeto del array tenga valores
  // ya que el array pLFielArrayValues se inicializa [{}]
  const isArrayEmpty = (arr) => arr.length === 1 && Object.keys(arr[0]).length === 0;
  const isPOrLEmpty =
    isArrayEmpty(pLFieldArrayValues) || pLFieldArrayValues.some(hasNullOrEmptyObj);

  useEffect(() => {
    if (contractNumber) {
      if (isMonthly !== undefined) {
        fetchPositions();
      }
    }
  }, [contractNumber, isMonthly, fetchPositions]);

  return {
    handleAddPL,
    handleSuprPL,
    handleSetLines,
    fetchLines,
    handleChangeLineValue,
    handleChangePosition,
    handleChangePositionValue,
    handleChangeAmount,
    handleChangeAmountValue,
    isPOrLEmpty,
    duplicatePositionLine,
    loading,
    changeLoaderState,
    lines,
    changeLineState,
    pLFieldArrayValues,
    changePLFieldArrayValues,
    fetchPositions,
    positions
  };
};

export default useMultiplPositionAndLine;
